import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin, Tabs } from 'antd';
import {SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import UPM from '../../constants/urlPermissionMappings'
import {PAGE_SIZE_DEFAULT} from '../../constants/appConstant'
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
const storage = window.localStorage
const { TabPane } = Tabs;
@inject('emailListStore', 'accountStore')
@observer
class emailList extends Component {
  state = {
    type: "1",
  }
  componentDidMount() {
    const {emailListStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    emailListStore.onGetStatus(this.state.type==='1' ? 'taskStatus' :'emailSendStatus')
    emailListStore.onGetGroup({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    }).then(res=> {
      if (res?.code === 0) {
        this.handleSearch(this.state.type, res?.data[0]?.id)
        emailListStore.onGetTemplate({
          'marketGroupId': res?.data[0]?.id
        })
        emailListStore.onGetConcater({
          marketGroupId: res?.data[0]?.id
        })
      }
    })
  }
  handleSearch = (value, marketGroupId) => {
    const {emailListStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const params = {
      page: 1, 
      size: PAGE_SIZE_DEFAULT, 
      marketGroupId: value === '2' ? marketGroupId : null,
      date: null,
    }
    if(value==='1') {
      emailListStore.onSearchJobAction({
        ...params,
        isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      })
      emailListStore.onGetStatus('taskStatus')
    } else {
      emailListStore.onSearchComplateAction(params)
      emailListStore.onGetStatus('emailSendStatus')
    }
  }
  onChange = (value) => {
    const {emailListStore} = this.props
    const {groupList} = emailListStore
    this.setState({
      type: value
    })
    this.handleSearch(value, groupList[0]?.id)
  }
  render() {
    const { emailListStore, location, t } = this.props
    const { isFetching } = emailListStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <div className="searchFormTitle" style={{background: 'white', padding: '0 15px'}}>
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Tabs activeKey={this.state.type} onChange={this.onChange} className='messagesTabs marketingSmsTemplateTabs'>
            <TabPane tab='待发送' key="1">
              <SearchForm type={this.state.type} location={location} />
              <SearchResult type={this.state.type} />
            </TabPane>
            <TabPane tab='已提交' key="2">
              <SearchForm type={this.state.type} location={location} />
              <SearchResult type={this.state.type} />
            </TabPane>
          </Tabs>
        </div>
      </Spin>
    );
  }
}
export default withTranslation()(emailList)
